<template>
    <div class="flex flex-col tracking-wider w-full max-w-[530px] p-8 border border-gray-100 lg:border-gray-300 rounded-md bg-gray-100 text-gray-800">
        <div class="text-xl pb-6 border-b border-gray-300 w-full flex justify-center text-center">Email Verification</div>
        <div v-if="isLoading" class="flex flex-col justify-between items-center pt-8">
            <div class="w-full flex justify-center items-center">
                Please wait while we verify your email address.
            </div>
            <div class="w-12 h-12 py-8">
                <LoadingSpinner />
            </div>
        </div>
        <div v-else class="flex justify-center pt-8">
            <div v-if="verificationResponseType=='success'" class="flex flex-col justify-center items-center space-y-4">
                <div class="whitespace-pre-wrap text-center">
                    Successfully verified your email address.
                </div>
                <div class="whitespace-pre-wrap text-center">
                    Redirecting you to the login page.
                </div>
                <div class="whitespace-pre-wrap text-center text-4xl text-dark-primary animate-pulse h-5">
                    <span v-if="timeRemaining">{{ timeRemaining }}</span>
                </div>
            </div>
            <div v-else-if="verificationResponseType=='error'" class="flex flex-col justify-center items-center space-y-4">
                <div class="whitespace-pre-wrap center w-full">We are unable to verify your email address.</div>
                <div class="whitespace-pre-wrap center w-full">Either this email has already been verified or your link has expired.</div>
                <div class="whitespace-pre-wrap center w-full">Please <tracked-link :link="{ path: '/', label: 'Home', displayLabel: false, class: 'inline'}"><span class="text-indigo-600 underline underline-offset-2 font-bold hover:text-indigo-900">sign in</span></tracked-link> or click <tracked-link :link="{ path: '/resend-email-verification/null', label: 'Resend Email Verification', displayLabel: false, class: 'inline'}"><span class="text-indigo-600 underline underline-offset-2 font-bold hover:text-indigo-900">here</span></tracked-link> to resend an email verification link.</div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, ref, onMounted } from 'vue';
import TrackedLink from '../nav-bar-link-components/TrackedLink.vue';
import LoadingSpinner from '../base-components/LoadingSpinner.vue';

import { useRouter } from 'vue-router';
import { verifyEmail } from '@/services/Auth';


const props = defineProps(['verificationKey'])
const router = useRouter()

const isLoading = ref(false)
const verificationResponseType = ref(null)
const timeRemaining= ref(null)

onMounted(() => {
    if(!props.verificationKey) {
        alert('Missing verification key')
    } else {
        verifyNewUserEmail(props.verificationKey)
    }
})

async function verifyNewUserEmail(verificationKey) {
    isLoading.value = true
    const response = await verifyEmail(verificationKey)

    setTimeout(() => {
        isLoading.value = false
        console.log('response')
        console.log(response)
        if(response && response.status == 200) {
            verificationResponseType.value = 'success'
            let timer = 10
            const countdownInterval = setInterval(() => {
                let seconds = timer % 60;
                seconds = seconds < 10 ? '0' + seconds : seconds;
                timeRemaining.value = seconds
                if(--timer<0) {
                    router.push('/login')
                    clearInterval(countdownInterval)
                }
            }, 1000)
        } else {
            verificationResponseType.value = 'error'
        }
    }, 2000)
}
</script>